import './index.scss'

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { AuthProvider } from './context/AuthContext'
import { NotifProvider } from './context/NotifContext'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <AuthProvider>
      <NotifProvider>
        <App />
      </NotifProvider>
    </AuthProvider>
  </React.StrictMode>
)
